// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yAkG1","colMin":"styles_colMin__2Liud"};